import React, { useState } from "react";
import {
  Box,
  Input,
  Stack,
  Button,
  Flex,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
  Tooltip,
  Grid,
} from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { MdDelete, MdAddCircleOutline } from "react-icons/md";
import { DeleteIcon } from "@chakra-ui/icons";
import Select from "react-select";
import { FaPlus } from "react-icons/fa";
import CustomInput from "components/common/customInput/CustomInput";
import HeadingSS from "./BsesPoc/components/common/Heading/HeadingSS";
interface FormData {
  [key: string]: {
    [nestedKey: string]: string | Test[];
  };
}

interface Test {
  name: string;
  subtests: Subtest[];
}

interface Subtest {
  name: string;
  value: string | number;
  units: string;
  reference: string;
}

const CurbeyTable = ({ formData, setFormData }: any) => {
  const [openTestModel, setOpenTestModel] = useState<any>({
    open: false,
    value: undefined,
    type: "",
    rest: null,
  });

  const handleKeyChange = (oldKey: string, newKey: string) => {
    setFormData((prevState: any) => {
      const newData: FormData = {};
      Object.keys(prevState).forEach((key) => {
        if (key === oldKey) {
          newData[newKey] = prevState[oldKey];
        } else {
          newData[key] = prevState[key];
        }
      });
      return newData;
    });
  };

  const handleFieldKeyChange = (
    objectKey: string,
    oldFieldKey: string,
    newFieldKey: string
  ) => {
    setFormData((prevState: any) => {
      const updatedData: any = {};
      for (const key in prevState) {
        if (Object.prototype.hasOwnProperty.call(prevState, key)) {
          if (key === objectKey) {
            const updatedObject: any = {};
            for (const fieldKey in prevState[key]) {
              if (
                Object.prototype.hasOwnProperty.call(prevState[key], fieldKey)
              ) {
                const newKey =
                  fieldKey === oldFieldKey ? newFieldKey : fieldKey;
                updatedObject[newKey] = prevState[key][fieldKey];
              }
            }
            updatedData[key] = updatedObject;
          } else {
            updatedData[key] = prevState[key];
          }
        }
      }
      return updatedData;
    });
  };

  const handleChange = (objectKey: string, fieldKey: string, value: string) => {
    setFormData((prevData: any) => ({
      ...prevData,
      [objectKey]: {
        ...prevData[objectKey],
        [fieldKey]: value,
      },
    }));
  };

  const handleAddObject = (
    position: "before" | "after",
    objectKey: string,
    newObjKey?: string
  ) => {
    if (newObjKey) {
      const updatedData = { ...formData };
      const objectKeys = Object.keys(updatedData);
      const index = objectKeys.indexOf(objectKey);
      const insertIndex = position === "before" ? index : index + 1;
      updatedData[newObjKey] = {};
      const updatedDataArray = Object.entries(updatedData);
      updatedDataArray.splice(insertIndex, 0, [newObjKey, {}]);
      setFormData(Object.fromEntries(updatedDataArray));
      setOpenTestModel({
        value: undefined,
        rest: null,
        open: false,
        type: null,
      });
    }
  };

  const handleNewTestObject = (
    position: "before" | "after",
    test: string,
    objectKey: string
  ) => {
    setFormData((prev: any) => ({
      ...prev,
      tests: [
        {
          name: "",
          subtests: [{ name: "", value: "", units: "", refrence: "" }],
        },
      ],
    }));
  };

  const handleDeleteObject = (objectKey: string) => {
    const updatedData = { ...formData };
    delete updatedData[objectKey];
    setFormData(updatedData);
  };

  const handleAddField = (
    objectKey: string,
    position: "before" | "after",
    fieldKey: string
  ) => {
    const newFieldKey = openTestModel.value;
    if (objectKey && newFieldKey) {
      const updatedData = { ...formData };
      const fieldKeys = Object.keys(updatedData[objectKey]);
      const index = fieldKeys.indexOf(fieldKey);
      let insertIndex = position === "before" ? index : index + 1;
      if (insertIndex < 0) {
        insertIndex = 0;
      } else if (insertIndex > fieldKeys.length) {
        insertIndex = fieldKeys.length;
      }
      const newFields: any = {
        ...updatedData[objectKey],
        [newFieldKey]: "",
      };
      const updatedFields = [
        ...fieldKeys.slice(0, insertIndex),
        newFieldKey,
        ...fieldKeys.slice(insertIndex),
      ];
      updatedData[objectKey] = Object.fromEntries(
        updatedFields.map((key) => [key, newFields[key]])
      );
      setFormData(updatedData);
      setOpenTestModel({
        value: undefined,
        rest: null,
        open: false,
        type: null,
      });
    }
  };

  const handleDeleteField = (objectKey: string, fieldKey: string) => {
    const updatedData = { ...formData };
    delete updatedData[objectKey][fieldKey];
    setFormData(updatedData);
  };

  const handleAddSubtest = (
    testIndex: number,
    subtestIndex: number,
    position?: "before" | "after"
  ) => {
    const updatedData: any = { ...formData };
    const newSubtest = {
      name: "",
      value: "",
      units: "",
      reference: "",
    };

    if (position === "before") {
      updatedData?.tests[testIndex]?.subtests?.splice(
        subtestIndex,
        0,
        newSubtest
      );
    } else {
      updatedData?.tests[testIndex]?.subtests?.splice(
        subtestIndex + 1,
        0,
        newSubtest
      );
    }
    setFormData(updatedData);
  };

  const handleDeleteSubtest = (testIndex: number, subtestIndex: number) => {
    const updatedData: any = { ...formData };
    updatedData?.tests[testIndex]?.subtests?.splice(subtestIndex, 1);
    setFormData(updatedData);
    if (subtestIndex === 0) {
      handleAddSubtest(testIndex, subtestIndex);
    }
  };

  const handleEditSubtest = (
    testIndex: number,
    subtestIndex: number,
    fieldKey: string,
    value: string
  ) => {
    const updatedData: any = { ...formData };
    const test = updatedData?.tests[testIndex];
    if (test) {
      const subtest = test?.subtests[subtestIndex];
      if (subtest) {
        updatedData.tests[testIndex].subtests[subtestIndex] = {
          ...subtest,
          [fieldKey]: value,
        };
        setFormData(updatedData);
      }
    }
  };

  const handleAddTest = () => {
    const updatedData: any = { ...formData };
    updatedData.tests.push({
      name: "",
      subtests: [
        {
          name: "",
          value: "",
          units: "",
          reference: "",
        },
      ],
    });
    setFormData(updatedData);
  };

  const handleNestedAddTest = (
    position: "before" | "after",
    testIndex?: number
  ) => {
    const updatedData: any = { ...formData };
    const newTest = {
      name: "",
      subtests: [
        {
          name: "",
          subtests: [
            {
              name: "",
              value: "",
              units: "",
              reference: "",
            },
          ],
        },
      ],
    };
    if (testIndex || testIndex === 0) {
      const insertIndex = position === "before" ? testIndex : testIndex + 1;
      updatedData?.tests?.splice(insertIndex, 0, newTest);
      setFormData(updatedData);
    } else {
      updatedData?.tests?.push(newTest);
      setFormData(updatedData);
    }
  };

  const handleAddTestIndex = (
    position: "before" | "after",
    testIndex: number
  ) => {
    const updatedData: any = { ...formData };
    const newTest = {
      name: "",
      subtests: [
        {
          name: "",
          value: "",
          units: "",
          reference: "",
        },
      ],
    };
    const insertIndex = position === "before" ? testIndex : testIndex + 1;
    updatedData?.tests?.splice(insertIndex, 0, newTest);
    setFormData(updatedData);
  };

  const handleEditTestName = (testIndex: number, newName: string) => {
    const updatedData: any = { ...formData };
    const test = updatedData.tests[testIndex];
    if (test) {
      updatedData.tests[testIndex] = {
        ...test,
        name: newName,
      };
      setFormData(updatedData);
    }
  };

  const handleDeleteTest = (testIndex: number) => {
    const updatedData: any = { ...formData };
    updatedData.tests.splice(testIndex, 1);
    setFormData(updatedData);
  };

  const handleAddNestedSubtest = (
    testIndex: number,
    subtestIndex: number,
    position: "before" | "after",
    subIndex: number
  ) => {
    const updatedData: any = { ...formData };
    const test = updatedData.tests[testIndex];
    if (test) {
      const subtest = test.subtests[subtestIndex];
      if (subtest && subtest.subtests) {
        const newNestedSubtest = {
          name: "",
          value: "",
          units: "",
          reference: "",
        };

        if (position === "before") {
          updatedData?.tests[testIndex]?.subtests[
            subtestIndex
          ]?.subtests.splice(subIndex, 0, newNestedSubtest);
        } else if (position === "after") {
          updatedData?.tests[testIndex]?.subtests[
            subtestIndex
          ]?.subtests.splice(subIndex + 1, 0, newNestedSubtest);
        }
        setFormData(updatedData);
      }
    }
  };

  const deleteSubtestInsidetheSubtests = (
    testIndex: number,
    subtestIndex: number
  ) => {
    const updatedData: any = { ...formData };
    const test: any = updatedData?.tests[testIndex];
    if (test && test?.subtests.length > subtestIndex) {
      test.subtests.splice(subtestIndex, 1);
      setFormData(updatedData);
    }
  };

  const addSubtestInsidetheSubtests = (
    testIndex: number,
    subtestIndex: number,
    position: "before" | "after"
  ) => {
    const updatedData: any = { ...formData };
    const test: any = updatedData.tests[testIndex];
    if (test) {
      const newTest = {
        name: "",
        subtests: [
          {
            name: "",
            value: "",
            units: "",
            reference: "",
          },
        ],
      };
      if (position === "before") {
        test.subtests.splice(subtestIndex, 0, newTest);
      } else if (position === "after") {
        test.subtests.splice(subtestIndex + 1, 0, newTest);
      }
      setFormData(updatedData);
    }
  };

  const handleEditNestedSubtest = (
    testIndex: number,
    subtestIndex: number,
    subIndex: number,
    fieldKey: string,
    value: string
  ) => {
    const updatedData: any = { ...formData };
    const test = updatedData.tests[testIndex];
    if (test) {
      const subtest = test.subtests[subtestIndex];
      if (subtest && subtest.subtests) {
        updatedData.tests[testIndex].subtests[subtestIndex].subtests[subIndex] =
          {
            ...subtest.subtests[subIndex],
            [fieldKey]: value,
          };
        setFormData(updatedData);
      }
    }
  };

  const handleDeleteNestedSubtest = (
    testIndex: number,
    subtestIndex: number,
    subIndex: number
  ) => {
    const updatedData: any = { ...formData };
    const test = updatedData.tests[testIndex];
    if (test) {
      const subtest = test.subtests[subtestIndex];
      if (subtest && subtest.subtests) {
        updatedData.tests[testIndex].subtests[subtestIndex].subtests.splice(
          subIndex,
          1
        );
        setFormData(updatedData);
      }
    }
    if (subIndex === 0) {
      handleAddNestedSubtest(testIndex, subtestIndex, "after", 1);
    }
  };

  const handleAddNestedSubtestBefore = (
    testIndex: number,
    subtestIndex: number,
    subIndex: number
  ) => {
    handleAddNestedSubtest(testIndex, subtestIndex, "before", subIndex);
  };

  const handleAddNestedSubtestAfter = (
    testIndex: number,
    subtestIndex: number,
    subIndex: number
  ) => {
    handleAddNestedSubtest(testIndex, subtestIndex, "after", subIndex);
  };

  const renderSubtests = (
    subtest: any,
    subtestIndex: number,
    testIndex: number
  ) => {
    return !subtest.subtests ? (
      <Flex flexDirection="column">
        <Table className="cureBayTable">
          {subtestIndex === 0 && (
            <Thead>
              <Th>Name</Th>
              <Th>Value</Th>
              <Th>Units</Th>
              <Th>Refrence</Th>
              <Th>Actions</Th>
            </Thead>
          )}
          <Tbody>
            <Tr key={subtestIndex}>
              <Td>
                <Input
                  value={subtest.name}
                  onChange={(e) =>
                    handleEditSubtest(
                      testIndex,
                      subtestIndex,
                      "name",
                      e.target.value
                    )
                  }
                  placeholder="Name"
                  w="15rem"
                  fontSize="sm"
                />
              </Td>
              <Td>
                <Input
                  value={subtest.value}
                  onChange={(e) =>
                    handleEditSubtest(
                      testIndex,
                      subtestIndex,
                      "value",
                      e.target.value
                    )
                  }
                  placeholder="Value"
                  fontSize="sm"
                />
              </Td>
              <Td>
                <Input
                  value={subtest.units}
                  onChange={(e) =>
                    handleEditSubtest(
                      testIndex,
                      subtestIndex,
                      "units",
                      e.target.value
                    )
                  }
                  placeholder="Units"
                  fontSize="sm"
                />
              </Td>
              <Td>
                <Input
                  value={subtest.reference}
                  onChange={(e) =>
                    handleEditSubtest(
                      testIndex,
                      subtestIndex,
                      "reference",
                      e.target.value
                    )
                  }
                  w="8rem"
                  placeholder="Reference"
                  fontSize="sm"
                />
              </Td>
              <Td>
                <Flex justifyContent="end" alignItems="center" columnGap={2}>
                  <Tooltip label="Delete" placement="left" hasArrow>
                    <Button
                      onClick={() =>
                        handleDeleteSubtest(testIndex, subtestIndex)
                      }
                      colorScheme="red"
                      variant="outline"
                      fontSize="sm"
                    >
                      <DeleteIcon />
                    </Button>
                  </Tooltip>

                  <Tooltip label="Add" hasArrow placement="left">
                    <Popover placement="bottom-start" closeOnBlur={true}>
                      <PopoverTrigger>
                        <Button
                          bg="teal.400"
                          color="white"
                          _hover={{ bg: "teal.500" }}
                          fontSize="sm"
                        >
                          <FaPlus />
                        </Button>
                      </PopoverTrigger>
                      <PopoverContent>
                        <PopoverArrow />
                        <PopoverCloseButton />
                        <PopoverBody>
                          <Flex
                            p={5}
                            columnGap={2}
                            flexDirection="column"
                            rowGap={2}
                          >
                            <Box>
                              <Button
                                onClick={() =>
                                  handleAddSubtest(
                                    testIndex,
                                    subtestIndex,
                                    "before"
                                  )
                                }
                                w="100%"
                                // leftIcon={<MdAddCircleOutline />}
                                bg="teal.400"
                                fontSize="sm"
                                color="white"
                                _hover={{ bg: "teal.500" }}
                              >
                                Add Before
                              </Button>
                            </Box>
                            <Box>
                              <Button
                                onClick={() =>
                                  handleAddSubtest(
                                    testIndex,
                                    subtestIndex,
                                    "after"
                                  )
                                }
                                // leftIcon={<MdAddCircleOutline />}
                                w="100%"
                                bg="teal.400"
                                color="white"
                                fontSize="sm"
                                _hover={{ bg: "teal.500" }}
                              >
                                Add After
                              </Button>
                            </Box>
                          </Flex>
                        </PopoverBody>
                      </PopoverContent>
                    </Popover>
                  </Tooltip>
                </Flex>
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </Flex>
    ) : (
      <Box boxShadow="sm" borderColor="2px" mt={3}>
        <Flex columnGap={3} mt={1} mb={3} flexDirection="column">
          <Flex justifyContent="space-between" mb={2} alignItems="center">
            <Text fontWeight="bold">Subtests</Text>
            <Tooltip label="Add" hasArrow placement="left">
              <Popover placement="bottom-start" closeOnBlur={true}>
                <PopoverTrigger>
                  <Button
                    bg="teal.400"
                    color="white"
                    fontSize="sm"
                    _hover={{ bg: "teal.500" }}
                  >
                    <FaPlus />
                  </Button>
                </PopoverTrigger>
                <PopoverContent>
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverBody>
                    <Flex p={5} columnGap={2} flexDirection="column" rowGap={2}>
                      <Box>
                        <Button
                          onClick={() => {
                            addSubtestInsidetheSubtests(
                              testIndex,
                              subtestIndex,
                              "before"
                            );
                          }}
                          w="100%"
                          // leftIcon={<MdAddCircleOutline />}
                          bg="teal.400"
                          color="white"
                          fontSize="sm"
                          _hover={{ bg: "teal.500" }}
                        >
                          Add Before
                        </Button>
                      </Box>
                      <Box>
                        <Button
                          onClick={() => {
                            addSubtestInsidetheSubtests(
                              testIndex,
                              subtestIndex,
                              "after"
                            );
                          }}
                          // leftIcon={<MdAddCircleOutline />}
                          w="100%"
                          bg="teal.400"
                          color="white"
                          fontSize="sm"
                          _hover={{ bg: "teal.500" }}
                        >
                          Add After
                        </Button>
                      </Box>
                      {/* <Tooltip
                        label="Delete Subtest"
                        placement="left"
                        hasArrow
                        arrowSize={5}
                      > */}
                      <Button
                        mt={2}
                        leftIcon={<DeleteIcon />}
                        onClick={() =>
                          deleteSubtestInsidetheSubtests(
                            testIndex,
                            subtestIndex
                          )
                        }
                        colorScheme="red"
                        fontSize="sm"
                        variant="outline"
                      >
                        {/* <DeleteIcon />  */}
                        Delete Subtest
                      </Button>
                      {/* </Tooltip> */}
                    </Flex>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            </Tooltip>
          </Flex>
          <Input
            value={subtest.name}
            onChange={(e) =>
              handleEditSubtest(testIndex, subtestIndex, "name", e.target.value)
            }
            placeholder="Name"
            fontSize="sm"
          />
        </Flex>
        <Table className="cureBayTable">
          <Thead>
            <Th>Name</Th>
            <Th>Value</Th>
            <Th>Units</Th>
            <Th>Refrence</Th>
            <Th>Actions</Th>
          </Thead>
          <Tbody>
            {subtest.subtests.map((sub: any, subIndex: number) => (
              <Tr key={subIndex}>
                <Td>
                  <Input
                    value={sub.name}
                    onChange={(e) =>
                      handleEditNestedSubtest(
                        testIndex,
                        subtestIndex,
                        subIndex,
                        "name",
                        e.target.value
                      )
                    }
                    placeholder="Name"
                    w="15rem"
                    fontSize="sm"
                  />
                </Td>
                <Td>
                  <Input
                    value={sub.value}
                    onChange={(e) =>
                      handleEditNestedSubtest(
                        testIndex,
                        subtestIndex,
                        subIndex,
                        "value",
                        e.target.value
                      )
                    }
                    placeholder="Value"
                    fontSize="sm"
                  />
                </Td>
                <Td>
                  <Input
                    value={sub.units}
                    onChange={(e) =>
                      handleEditNestedSubtest(
                        testIndex,
                        subtestIndex,
                        subIndex,
                        "units",
                        e.target.value
                      )
                    }
                    placeholder="Units"
                    fontSize="sm"
                  />
                </Td>
                <Td>
                  <Input
                    value={sub.reference}
                    onChange={(e) =>
                      handleEditNestedSubtest(
                        testIndex,
                        subtestIndex,
                        subIndex,
                        "reference",
                        e.target.value
                      )
                    }
                    placeholder="Reference"
                    w="8rem"
                    fontSize="sm"
                  />
                </Td>
                <Tr key={subIndex}>
                  {/* Existing code */}
                  <Td columnGap={3}>
                    <Flex columnGap={2}>
                      <Tooltip placement="left" label="Delete" hasArrow>
                        <Button
                          onClick={() =>
                            handleDeleteNestedSubtest(
                              testIndex,
                              subtestIndex,
                              subIndex
                            )
                          }
                          colorScheme="red"
                          fontSize="sm"
                          variant="outline"
                        >
                          <DeleteIcon />
                        </Button>
                      </Tooltip>
                      <Tooltip label="Add" hasArrow placement="left">
                        <Popover placement="bottom-start" closeOnBlur={true}>
                          <PopoverTrigger>
                            <Button
                              bg="teal.400"
                              color="white"
                              fontSize="sm"
                              _hover={{ bg: "teal.500" }}
                            >
                              <FaPlus />
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent>
                            <PopoverArrow />
                            <PopoverCloseButton />
                            <PopoverBody>
                              <Flex
                                p={5}
                                columnGap={2}
                                flexDirection="column"
                                rowGap={2}
                              >
                                <Box>
                                  <Button
                                    onClick={() =>
                                      handleAddNestedSubtestBefore(
                                        testIndex,
                                        subtestIndex,
                                        subIndex
                                      )
                                    }
                                    w="100%"
                                    // leftIcon={<MdAddCircleOutline />}
                                    bg="teal.400"
                                    color="white"
                                    fontSize="sm"
                                    _hover={{ bg: "teal.500" }}
                                  >
                                    Add Before
                                  </Button>
                                </Box>
                                <Box>
                                  <Button
                                    onClick={() =>
                                      handleAddNestedSubtestAfter(
                                        testIndex,
                                        subtestIndex,
                                        subIndex
                                      )
                                    }
                                    // leftIcon={<MdAddCircleOutline />}
                                    w="100%"
                                    bg="teal.400"
                                    fontSize="sm"
                                    color="white"
                                    _hover={{ bg: "teal.500" }}
                                  >
                                    Add After
                                  </Button>
                                </Box>
                              </Flex>
                            </PopoverBody>
                          </PopoverContent>
                        </Popover>
                      </Tooltip>
                    </Flex>
                  </Td>
                </Tr>{" "}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    );
  };

  return (
    <>
      <Box>
        {Object.entries(formData)?.map(
          ([objectKey, fields]: any, index: number) => {
            return (
              <Stack
                key={index}
                mb={4}
                borderWidth="1px"
                p={4}
                borderRadius="md"
              >
                {objectKey === "tests" ? (
                  <Text casing="capitalize" fontSize="xl" fontWeight={600}>
                    {objectKey}
                  </Text>
                ) : (
                  <Input
                    name={`main_field_${index}`}
                    value={objectKey}
                    onChange={(e) => handleKeyChange(objectKey, e.target.value)}
                    placeholder="Object Key"
                    mb={2}
                    fontSize="sm"
                  />
                )}
                {objectKey === "tests" ? (
                  <>
                    {Array.isArray(fields) &&
                      fields?.map((test: Test, testIndex: number) => (
                        <Box key={testIndex} mb={4}>
                          <Flex alignItems="center" columnGap={2} mb={2}>
                            <Input
                              value={test.name}
                              onChange={(e) =>
                                handleEditTestName(testIndex, e.target.value)
                              }
                              placeholder="Test Name"
                              fontSize="sm"
                            />
                            <Popover
                              placement="bottom-start"
                              closeOnBlur={true}
                            >
                              <PopoverTrigger>
                                <Button
                                  bg="teal.400"
                                  color="white"
                                  fontSize="sm"
                                  _hover={{ bg: "teal.500" }}
                                >
                                  Action
                                </Button>
                              </PopoverTrigger>
                              <PopoverContent>
                                <PopoverArrow />
                                <PopoverCloseButton />
                                <PopoverBody>
                                  <Flex
                                    p={5}
                                    columnGap={2}
                                    flexDirection="column"
                                  >
                                    <Box>
                                      <CustomInput
                                        name="addTest"
                                        type="select"
                                        options={[
                                          {
                                            value: "after",
                                            label: "Add after",
                                          },
                                          {
                                            value: "before",
                                            label: "Add before",
                                          },
                                        ]}
                                        onChange={(option: any) =>
                                          option &&
                                          handleAddTestIndex(
                                            option.value,
                                            testIndex
                                          )
                                        }
                                        placeholder="Add Test"
                                      />
                                    </Box>
                                    <Box mt={2}>
                                      <CustomInput
                                        name="addNestedTest"
                                        type="select"
                                        options={[
                                          {
                                            value: "before",
                                            label: "Add before Nested Test",
                                          },
                                          {
                                            value: "after",
                                            label: "Add after Nested Test",
                                          },
                                        ]}
                                        onChange={(option: any) =>
                                          option &&
                                          handleNestedAddTest(
                                            option.value,
                                            testIndex
                                          )
                                        }
                                        placeholder="Add Nested Test"
                                      />
                                    </Box>
                                    {/* <Tooltip
                                    label="Delete Test"
                                    hasArrow
                                    arrowSize={5}
                                  > */}
                                    <Button
                                      mt={2}
                                      leftIcon={<DeleteIcon />}
                                      onClick={() =>
                                        handleDeleteTest(testIndex)
                                      }
                                      colorScheme="red"
                                      fontSize="sm"
                                      variant="outline"
                                    >
                                      Delete Test
                                      {/* <DeleteIcon /> */}
                                    </Button>
                                    {/* </Tooltip> */}
                                  </Flex>
                                </PopoverBody>
                              </PopoverContent>
                            </Popover>
                          </Flex>
                          {test?.subtests?.map((subtest, subtestIndex) =>
                            renderSubtests(subtest, subtestIndex, testIndex)
                          )}
                          {/* <Flex justifyContent="end">
                        <Button
                          onClick={() => handleAddSubtest(testIndex)}
                          leftIcon={<MdAddCircleOutline />}
                          mt={3}
                        >
                          Add Subtestss
                        </Button>
                      </Flex> */}
                        </Box>
                      ))}
                    <Flex justifyContent="end">
                      <Flex columnGap={4}>
                        <Button
                          onClick={handleAddTest}
                          mt={2}
                          leftIcon={<MdAddCircleOutline />}
                          bg="teal.400"
                          color="white"
                          fontSize="sm"
                          _hover={{ bg: "teal.500" }}
                        >
                          Add new Test
                        </Button>
                        <Button
                          onClick={() => handleNestedAddTest("after")}
                          mt={2}
                          leftIcon={<MdAddCircleOutline />}
                          bg="teal.400"
                          color="white"
                          fontSize="sm"
                          _hover={{ bg: "teal.500" }}
                        >
                          Add nested Test
                        </Button>
                      </Flex>
                    </Flex>
                  </>
                ) : (
                  <>
                    {Object.entries(fields)?.map(
                      ([fieldKey, value], index: number) => (
                        <Flex
                          key={`${fieldKey}_${index}`}
                          alignItems="center"
                          mb={2}
                        >
                          <Input
                            name={`field_${index}`}
                            value={fieldKey}
                            onChange={(e) =>
                              handleFieldKeyChange(
                                objectKey,
                                fieldKey,
                                e.target.value
                              )
                            }
                            placeholder="Field Key"
                            flex="1"
                            mr={2}
                            fontSize="sm"
                          />
                          <Input
                            value={value as string}
                            onChange={(e) =>
                              handleChange(objectKey, fieldKey, e.target.value)
                            }
                            placeholder="Field Value"
                            flex="1"
                            fontSize="sm"
                            mr={2}
                          />
                          <Flex columnGap={2}>
                            <Tooltip label="Delete" placement="left" hasArrow>
                              <Button
                                onClick={() =>
                                  handleDeleteField(objectKey, fieldKey)
                                }
                                colorScheme="red"
                                variant="outline"
                              >
                                <DeleteIcon />
                              </Button>
                            </Tooltip>

                            <Tooltip label="Add" hasArrow placement="left">
                              <Popover
                                placement="bottom-start"
                                closeOnBlur={true}
                              >
                                <PopoverTrigger>
                                  <Button
                                    bg="teal.400"
                                    fontSize="sm"
                                    color="white"
                                    _hover={{ bg: "teal.500" }}
                                  >
                                    <FaPlus />
                                  </Button>
                                </PopoverTrigger>
                                <PopoverContent>
                                  <PopoverArrow />
                                  <PopoverCloseButton />
                                  <PopoverBody>
                                    <Flex
                                      p={5}
                                      columnGap={2}
                                      flexDirection="column"
                                      rowGap={2}
                                    >
                                      <Box>
                                        <Button
                                          onClick={() => {
                                            setOpenTestModel({
                                              open: true,
                                              type: "key",
                                              rest: {
                                                objectKey: objectKey,
                                                position: "before",
                                                fieldKey: fieldKey,
                                              },
                                            });
                                          }}
                                          w="100%"
                                          // leftIcon={<MdAddCircleOutline />}
                                          bg="teal.400"
                                          fontSize="sm"
                                          color="white"
                                          _hover={{ bg: "teal.500" }}
                                        >
                                          Add Before
                                        </Button>
                                      </Box>
                                      <Box>
                                        <Button
                                          onClick={() => {
                                            // handleAddField(objectKey, "after", fieldKey)
                                            setOpenTestModel({
                                              open: true,
                                              type: "key",
                                              rest: {
                                                objectKey: objectKey,
                                                position: "after",
                                                fieldKey: fieldKey,
                                              },
                                            });
                                          }}
                                          // leftIcon={<MdAddCircleOutline />}
                                          w="100%"
                                          bg="teal.400"
                                          fontSize="sm"
                                          color="white"
                                          _hover={{ bg: "teal.500" }}
                                        >
                                          Add After
                                        </Button>
                                      </Box>
                                    </Flex>
                                  </PopoverBody>
                                </PopoverContent>
                              </Popover>
                            </Tooltip>
                          </Flex>
                        </Flex>
                      )
                    )}
                    {Object.keys(fields)?.length === 0 && (
                      <Stack spacing={2} mt={2}>
                        <Button
                          fontSize="sm"
                          onClick={() => {
                            setOpenTestModel({
                              open: true,
                              type: "key",
                              rest: {
                                objectKey: objectKey,
                                position: "before",
                                fieldKey: "",
                              },
                            });
                          }}
                          leftIcon={<MdAddCircleOutline />}
                          bg="teal.400"
                          color="white"
                          _hover={{ bg: "teal.500" }}
                        >
                          Add Field
                        </Button>
                      </Stack>
                    )}
                  </>
                )}
                <Box>
                  <Flex justifyContent="end" gap={4}>
                    <Button
                      onClick={() => handleDeleteObject(objectKey)}
                      mt={2}
                      leftIcon={<DeleteIcon />}
                      colorScheme="red"
                      fontSize="sm"
                      variant="outline"
                    >
                      Delete Object
                    </Button>
                    <Button
                      fontSize="sm"
                      onClick={() => {
                        setOpenTestModel({
                          open: true,
                          type: "object",
                          rest: { position: "before", objectKey: objectKey },
                        });
                      }}
                      mt={2}
                      leftIcon={<MdAddCircleOutline />}
                      bg="teal.400"
                      color="white"
                      _hover={{ bg: "teal.500" }}
                    >
                      Add Object Before
                    </Button>
                    <Button
                      fontSize="sm"
                      onClick={() => {
                        setOpenTestModel({
                          open: true,
                          type: "object",
                          rest: { position: "after", objectKey: objectKey },
                        });
                      }}
                      mt={2}
                      leftIcon={<MdAddCircleOutline />}
                      bg="teal.400"
                      color="white"
                      _hover={{ bg: "teal.500" }}
                    >
                      Add Object After
                    </Button>
                  </Flex>
                </Box>
              </Stack>
            );
          }
        )}
        <Button
          display="none"
          onClick={() => console.log(formData)}
          bg="teal.400"
          color="white"
          fontSize="sm"
          _hover={{ bg: "teal.500" }}
        >
          Save
        </Button>
        <Flex gap={2}>
          <Button
            display={
              Object.entries(formData)?.length === 0 ? undefined : "none"
            }
            // onClick={() => handleAddObject("before", "")}
            onClick={() => {
              setOpenTestModel({
                open: true,
                type: "object",
                rest: { position: "before", objectKey: "" },
              });
            }}
            mt={2}
            leftIcon={<MdAddCircleOutline />}
            bg="teal.400"
            color="white"
            fontSize="sm"
            _hover={{ bg: "teal.500" }}
          >
            Add Object
          </Button>
          <Button
            display={!formData.hasOwnProperty("tests") ? undefined : "none"}
            onClick={() => handleNewTestObject("before", "", "")}
            mt={2}
            leftIcon={<MdAddCircleOutline />}
            bg="teal.400"
            fontSize="sm"
            color="white"
            _hover={{ bg: "teal.500" }}
          >
            Add Test
          </Button>
        </Flex>
      </Box>
      <Modal
        isOpen={openTestModel.open}
        onClose={() =>
          setOpenTestModel({
            open: false,
            value: undefined,
            type: null,
            rest: null,
          })
        }
        isCentered
        size={{ base: "xs", lg: "md" }}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <HeadingSS headingSS="Add Key" />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              type="text"
              placeholder="Enter Key"
              borderRadius="md"
              fontSize="sm"
              borderColor="gray.400"
              _hover={{ borderColor: "gray.500" }}
              _focus={{ borderColor: "blue.400", boxShadow: "outline" }}
              value={openTestModel.value}
              onChange={(e: any) =>
                setOpenTestModel((prev: any) => ({
                  ...prev,
                  value: e.target.value,
                }))
              }
            />
          </ModalBody>
          <ModalFooter>
            <Button
              mr={3}
              onClick={() => {
                setOpenTestModel({
                  open: false,
                  value: undefined,
                  type: null,
                  rest: null,
                });
              }}
              bg={"red.400"}
              _hover={{ bg: "red.500" }}
              color="white"
              fontSize="sm"
            >
              Close
            </Button>
            <Button
              // variant="ghost"
              onClick={() => {
                if (openTestModel.type === "object") {
                  handleAddObject(
                    openTestModel.rest?.position,
                    openTestModel.rest?.objectKey,
                    openTestModel.value
                  );
                }
                if (openTestModel.type === "key") {
                  handleAddField(
                    openTestModel.rest?.objectKey,
                    openTestModel.rest?.position,
                    openTestModel.rest?.fieldKey
                  );
                }
              }}
              bg={"teal.300"}
              _hover={{ bg: "teal.400" }}
              color="white"
              fontSize="sm"
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
export default CurbeyTable;
